import { render, staticRenderFns } from "./goveslogin.vue?vue&type=template&id=6717026e&"
import script from "./goveslogin.vue?vue&type=script&lang=js&"
export * from "./goveslogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports